export default {
  en: {
    showMoreReviews: "show more reviews",
    reviews: [
      {
        username: "Sven Olbrechts",
        review: "It's <strong>highly addictive</strong> to get core insights on personally relevant topics without repetition or triviality. Added to that the apps ability to suggest kindred interests opens up a foundation of knowledge.",
        stars: 5,
        avatar: "sven.jpg"
      },
      {
        username: "Thi Viet Quynh Nguyen",
        review: "Great app. Good selection of book summaries you can read or listen to while commuting. Instead of scrolling through your social media news feed, this is a much better way to spend your spare time in my opinion.",
        stars: 5,
        avatar: "thi.jpg"
      },
      {
        username: "Jonathan Arana",
        review: "<strong>Life changing.</strong> The concept of being able to grasp a book's main point in such a short time truly opens multiple opportunities to grow every area of your life at a faster rate.",
        stars: 5,
        avatar: "jonathan.jpg"
      },
      {
        username: "Renee Daniels-Mantle",
        review: "Great app. Addicting. <strong>Perfect for wait times, morning coffee, evening before bed.</strong> Extremely well written, thorough, easy to use.",
        stars: 5,
        avatar: "renee.jpg"
      },
      {
        username: "Alex Nobbe Toussaint",
        review: "I've referred it to 6 people already. <strong>It really is a fantastic app if you're a knowledge seeker who happens to not like reading.</strong> I strongly recommend downloading this app and testing the free trial.",
        stars: 5,
        avatar: "alex.jpg"
      },
      {
        username: "Vanessa Velasquez",
        review: "Great app! you can learn a lot in only a few minutes of your time 🙌🏼🤓",
        stars: 5,
        avatar: "vanessa.jpg"
      },
      {
        username: "Luis G. Hernandez",
        review: "<strong>This app has changed my life.</strong> Seriously, just the fact I have all this knowledge condensed into a few minutes of my time has helped to shift my perspective, grow my knowledge and has improved my overall lifestyle. This app is recommended for people looking to learn more, learn quickly and apply it to your life.",
        stars: 5,
        avatar: "luis.jpg"
      },
      {
        username: "Sophia Pope",
        review: "Great concise bites. Amazing for busy people who don't have time to read through an entire book. ",
        stars: 5,
        avatar: "sophia.jpg"
      },
      {
        username: "Keith Engelhardt",
        review: "Fast and efficient to learn the key concepts in a book in 15 minutes or less. It's the app I start each day with.",
        stars: 5,
        avatar: "keith.jpg"
      },
      {
        username: "Joice Tae Ozaki",
        review: "I am completely hooked. This is a great app to get through books you've always wanted to read, but never had the time. And if you enjoy a read, you can always purchase the book and deep dive. I highly recommend it.",
        stars: 5,
        avatar: "joice.jpg"
      },
      {
        username: "Iga",
        review: "<strong>Selection and amount of the books available for blinks is really impressive</strong>, whenever I hear about a nonfiction book somewhere, I search for it on Blinkist and I'll most likely find it. I love the sleep mode so I listen to the blinks, fall asleep and app switches off itself. Of course it won't replace reading the book, but you can learn so much from these summaries - you can highlight your favourite parts and go back. Would definitely recommend to try out :)",
        stars: 5,
        avatar: "iga.jpg"
      },
      {
        username: "Diana Muturia",
        review: "Great app! Working from home and being able to learn in 15 min or less while preparing for the day is great!",
        stars: 5,
        avatar: "diana.jpg"
      },
      {
        username: "Jonny Miles-Prouten",
        review: "<strong>Pleasantly surprised - I wasn't sure if this would work but it's great.</strong> I am getting through a couple of books easily a day when out running. Also I've deleted Instagram, whatsapp and Facebook, and so instead of wasting time browsing them I read some Blinkist books instead.",
        stars: 5,
        avatar: "jonny.jpg"
      },
      {
        username: "Handyman",
        review: "Great app and idea in general. Each topic is more of a provoking thought than a detailed summary, which allows you to get a grasp of a new idea to play with. Personally, I listen on my commute and it often gives me new ideas on how to approach work for the day.",
        stars: 5,
        avatar: "handyman.jpg"
      },
      {
        username: "Hector Santillan",
        review: "The summary of books is just awesome and I've managed to listen to 120+ books already. <strong>Might not be the same as reading a whole book, but it sure is enlightening</strong> and gives you food for thought, new impulses and ideas. Give it a try and you'll love it. ",
        stars: 5,
        avatar: "hector.jpg"
      }
    ]
  },
  de: {
    showMoreReviews: "mehr Bewertungen ansehen",
    reviews: [
      {
        username: "Ines Spittel",
        review: "Ich bin begeistert. Ich liebe Bücher aber <strong>durch zwei kleine Kinder komme ich einfach nicht zum Lesen</strong>. Und ja, viele Bücher haben viel bla bla und die Quintessenz ist eigentlich ein Bruchteil.[break]Genau dafür ist Blinkist total genial! Es wird auf das Wesentliche reduziert, die Blinks sind gut verständlich, gut zusammengefasst und auch hörbar! Das ist super. 80 Euro für ein ganzes Jahr klingt viel, aber dafür unbegrenzt Zugriff auf 3000 Bücher. Und dieses <strong>Wissen und die Zeitersparnis ist unbezahlbar</strong>.",
        stars: 5,
        avatar: "ines.jpg"
      },
      {
        username: "Ekaterina Savchenko",
        review: "Extrem empfehlenswert. <strong>Statt sinnlos im Facebook zu scrollen höre ich jetzt täglich zwischen 3-4 \"Bücher\"</strong>. Bei manchen wird schnelle klar, dass der Kauf unnötig ist, da schon das wichtigste[break]zusammen gefasst wurde..bei anderen macht es Lust doch das Buch selbständig zu lesen. Wirklich toll",
        stars: 5,
        avatar: "ekaterina.jpg"
      },
      {
        username: "Nils Scharfe",
        review: "Einer der besten, bequemsten und sinnvollsten Apps die auf ein Handy gehören. <strong>Jeden morgen 15-20 Minuten für die eigene Weiterbildung/Entwicklung oder Wissen</strong>.",
        stars: 5,
        avatar: "nils.jpg"
      },
      {
        username: "Julia Pfister",
        review: "Viele tolle Bücher, auf deren Kernaussagen reduziert- präzise und ansprechend zusammengefasst. <strong>Endlich habe ich das Gefühl, Zeit für Bücher zu finden, für die ich sonst keine Zeit habe</strong>.",
        stars: 5,
        avatar: "julia.jpg"
      },
      {
        username: "Snipes Twitch",
        review: "Blinkist ist übersichtlich und einfach zu bedienen. Die ca 80 Euro im Jahr sind definitiv gut investiert wenn man bedankt was Bücher kosten oder welch Arbeit es macht immer im die Bib zu fahren und die Abgabetermine nicht zu vergessen. Blinkist fasst die Kernaussagen der Bücher in mehreren Abschnitten zusammen so dass du Stück für Stück den Inhalt deines Buches enthüllst. Viel Vergnügen beim Lesen, wachsen und lernen :)",
        stars: 5,
        avatar: "snipes.jpg"
      },
      {
        username: "Anja Schaeffer",
        review: "Achtung diese App <strong>macht süchtig</strong>! Habe sie direkt in meine Morgen-Routine integriert und liebe sie. Meine Favoriten Blinks habe ich abgespeichert und genieße sie regelmäßig wieder :) auch das kostenlose Abo ist cool! Jeden Tag wird man mit einem Blink des Tages überrascht :)",
        stars: 5,
        avatar: "anja.jpg"
      },
      {
        username: "Alida K.",
        review: "Blinkist ist für mich die einfachste & schnellste Möglichkeit, um mich effektiv & effizient weiterzubilden. Durch die Audioblinks & der Download-Funktion ist lesen nun immer & überall möglich. <strong>Ich kann mir täglich Wissen aus >10 Bücher aneignen</strong>. Vorallem die Bandbreite an unterschiedlichen Themen erweitert kontinuierlich meinen Horizont. Nie war Lernen so einfach & bequem. Ich bin begeistert & kann jedem diese App wärmstens empfehlen. Tausend Dank hierfür.",
        stars: 5,
        avatar: "alida.jpg"
      },
      {
        username: "Saskia vdH",
        review: "<strong>Tolle App. Endlich nutze ich die Zeit beim Töpfe abwaschen und kochen für sinnvolle Sachen, mich weiterzubilden</strong>. Ich lasse mir die Bücher einfach vorlesen und höre mit Bluetooth Kopfhörern. Perfekt! Hätte ich das bloß schon früher gemacht! Ich habe mir das erste Mal das Abo mit Rabatt gekauft. Empfehlenswert!",
        stars: 5,
        avatar: "saskia.jpg"
      },
      {
        username: "Wilfried StreinerFeb",
        review: "Ich habe schon lange das Pro Abo und ich liebe diese App. Ich lese gerne über viele verschiedene Themen, kann mich aber schwer konzentrieren und ein fettes Buch ist mir zu langweilig. Blinklist ist genau richtig, nur die Kernaussagen eines Buches. So lese ich fast täglich motivierende Blinks, die mir tatsächlich helfen. Wenn ein Buch mega interessant ist, kaufe ich es später als EBook um den Rest zu lesen. Danke für diese App",
        stars: 5,
        avatar: "wilfred.jpg"
      },
      {
        username: "Katrin Dolke",
        review: "Diese App ist grossartig. Ich würde gerne mehr Bücher lesen, aber meine Zeit reicht dafür nicht. Blinkist ermöglicht es mir in völlig verschiedene Themen reinzuschnuppern und meine Neugierde und mein Wissen zu erweitern. Nebenbei lerne ich viel über mich selbst, aber auch über vielseitige andere Themen. Themen, die ich gar nicht für sooo interessant gehalten hätte. Tolle Stimmen! <strong>Meine erste Bezahlapp und das will was heißen :-)</strong>",
        stars: 5,
        avatar: "katrin.jpg"
      }
    ]
  }
};
